import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Shot = ({ src, alt, label }) => (
  <figure className="relative border-[3px] border-brutal-yellow shadow-brutal-xl bg-brutal-black overflow-hidden">
    <div className="absolute top-3 left-3 z-10 bg-brutal-yellow border-[2.5px] border-brutal-black px-2.5 py-1 shadow-brutal-sm">
      <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-brutal-black">{label}</span>
    </div>
    <img src={src} alt={alt} loading="lazy" className="w-full h-auto block" />
  </figure>
);

export const Showcase = () => {
  const navigate = useNavigate();
  return (
    <section id="por-dentro" data-testid="showcase-section" className="py-24 sm:py-32 bg-brutal-black">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-brutal-yellow border-[2.5px] border-brutal-black px-3.5 py-1.5 shadow-brutal-xs">
            <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-brutal-black">TELAS REAIS DO SISTEMA</span>
          </div>
          <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white uppercase leading-[0.95]">
            Veja o sistema<br />
            <span className="text-brutal-yellow">por dentro.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-brutal-cream leading-relaxed font-medium">
            Nada de foto de banco de imagem. Estas são telas de verdade do painel do Pede é Fácil — exatamente o que você vai usar todos os dias na sua loja.
          </p>
        </div>

        <div className="mt-14 space-y-8">
          <Shot
            src="/screenshots/painel-pedidos.png"
            alt="Painel de pedidos em tempo real do Pede é Fácil (Kanban)"
            label="PEDIDOS EM TEMPO REAL"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <Shot
              src="/screenshots/painel-produtos.png"
              alt="Gestão de produtos com comando por IA no Pede é Fácil"
              label="CARDÁPIO + COMANDO POR IA"
            />
            <Shot
              src="/screenshots/painel-relatorios.png"
              alt="Relatórios de vendas do Pede é Fácil"
              label="RELATÓRIOS DE VENDAS"
            />
          </div>
        </div>

        <div className="mt-14 flex justify-center">
          <button
            data-testid="showcase-cta"
            onClick={() => navigate("/login", { state: { register: true } })}
            className="bg-brutal-yellow text-brutal-black border-[3px] border-brutal-black px-8 py-4 font-heading uppercase tracking-tight text-base shadow-brutal-md hover:translate-y-[-3px] hover:shadow-brutal-lg active:translate-y-[2px] active:shadow-brutal-sm transition-all inline-flex items-center justify-center gap-2"
          >
            Quero esse painel na minha loja
            <ArrowRight size={20} strokeWidth={3} />
          </button>
        </div>
      </div>
    </section>
  );
};
